<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="reasonsForDeliveryFailureHeadings" :data="reasonsForDeliveryFailure" :hasActions="true"
                                :hasNoPaging="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onReasonForDeliveryFailureActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" id="btnAddReasonForDeliveryFailure" @click="onAddReasonForDeliveryFailureClick">
                                    Add Reason For Delivery Failure
                                </button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="reasonForDeliveryFailureMarkAsActiveInactiveModal.heading"
                :modalId="reasonForDeliveryFailureMarkAsActiveInactiveModal.modalId"
                :isSaving="reasonForDeliveryFailureMarkAsActiveInactiveModal.isSaving"
                :showModal="reasonForDeliveryFailureMarkAsActiveInactiveModal.showModal"
                :isActive="reasonForDeliveryFailureMarkAsActiveInactiveModal.isActive"
                @closeClicked="reasonForDeliveryFailureMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="reasonForDeliveryFailureAddEditFormModal.heading"
            :modalId="reasonForDeliveryFailureAddEditFormModal.modalId"
            :isSaving="reasonForDeliveryFailureAddEditFormModal.isSaving"
            :showModal="reasonForDeliveryFailureAddEditFormModal.showModal"
            @closeClicked="onAddOrEditReasonForDeliveryFailureModalCloseClick"
            @saveButtonClicked="onAddOrEditReasonForDeliveryFailureSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="reasonInput">
                        Reason For Delivery Failure
                    </label>
                    <div class="text-danger" v-if="reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.description.hasError">
                        {{reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.description.errorMessage}}
                    </div>
                    <textarea class="form-control" id="reasonInput" v-model="reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.description.value"></textarea>
                </div>
            </form>
        </template>
    </modal-form>
</div>
